import type {
  KnowledgeEntity,
  KnowledgeLinkRef,
  KnowledgeRelatedEntity,
  KnowledgeStats,
} from "../utils/api";

/**
 * Fixed data for the design-review routes, which render without a backend so the
 * screenshot utility can capture these screens. Shaped like a real library:
 * a few kinds, a few mention counts, and names long enough to show truncation.
 */

const seen = { first_seen_at: "2026-04-02T10:12:00.000Z", last_seen_at: "2026-09-11T18:40:00.000Z" };

export const designReviewKnowledgeStats: KnowledgeStats = {
  nodes_by_kind: [
    { kind: "place", count: 683 },
    { kind: "topic", count: 415 },
    { kind: "ingredient", count: 234 },
    { kind: "link", count: 205 },
    { kind: "recipe", count: 32 },
    { kind: "song", count: 20 },
    { kind: "artist", count: 17 },
    { kind: "domain", count: 11 },
    { kind: "tag", count: 6 },
  ],
  edges_by_kind: [
    { kind: "mentions", count: 819 },
    { kind: "tagged", count: 582 },
  ],
  total_nodes: 1623,
  total_edges: 1961,
  linked_links: 205,
};

export const designReviewKnowledgeEntities: KnowledgeEntity[] = [
  {
    id: "entity-taipei",
    kind: "place",
    canonical_key: "google:ChIJL1cHXAbzbjQRaVScvwTwEec",
    label: "Taipei",
    props: { category: "city", google_maps_pin: "https://www.google.com/maps/search/?api=1&query=Taipei" },
    mentions: 14,
    ...seen,
  },
  {
    id: "entity-yongkang",
    kind: "place",
    canonical_key: "google:ChIJff6pZXCpQjQRHi3vcbjQip8",
    label: "Yonghe Chia Hsiang Soy Milk",
    props: {
      address: "Yongkang St, Da’an District, Taipei",
      category: "breakfast",
      google_maps_pin: "https://www.google.com/maps/search/?api=1&query=Yonghe+Chia+Hsiang+Soy+Milk",
    },
    mentions: 3,
    ...seen,
  },
  {
    id: "entity-travel",
    kind: "topic",
    canonical_key: "travel",
    label: "travel",
    props: {},
    mentions: 18,
    ...seen,
  },
  {
    id: "entity-salt",
    kind: "ingredient",
    canonical_key: "salt",
    label: "salt",
    props: {},
    mentions: 20,
    ...seen,
  },
  {
    id: "entity-touch",
    kind: "song",
    canonical_key: "spotify:2QZw9tAtxNwY1FzwjMd5ic",
    label: "Touch — Hybrid Minds",
    props: {
      title: "Touch",
      artist: "Hybrid Minds",
      spotify_url: "https://open.spotify.com/track/2QZw9tAtxNwY1FzwjMd5ic",
    },
    mentions: 2,
    ...seen,
  },
  {
    id: "entity-miso",
    kind: "recipe",
    canonical_key: "miso soup with silken tofu",
    label: "Miso soup with silken tofu",
    props: { servings: 2, prep_time: "10 min", cook_time: "15 min" },
    mentions: 1,
    ...seen,
  },
  {
    id: "entity-instagram",
    kind: "domain",
    canonical_key: "instagram com",
    label: "instagram.com",
    props: {},
    mentions: 189,
    ...seen,
  },
];

export const designReviewKnowledgeEntity: KnowledgeEntity = designReviewKnowledgeEntities[1];

export const designReviewKnowledgeRelated: KnowledgeRelatedEntity[] = [
  { ...designReviewKnowledgeEntities[0], depth: 2 },
  { ...designReviewKnowledgeEntities[2], depth: 2 },
  {
    id: "entity-taiwan-travel",
    kind: "topic",
    canonical_key: "taiwan travel",
    label: "Taiwan travel",
    props: {},
    mentions: 13,
    depth: 2,
    ...seen,
  },
  {
    id: "entity-breakfast",
    kind: "topic",
    canonical_key: "taiwanese breakfast",
    label: "Taiwanese breakfast",
    props: {},
    mentions: 4,
    depth: 2,
    ...seen,
  },
  { ...designReviewKnowledgeEntities[4], depth: 2 },
];

export const designReviewKnowledgeLinks: KnowledgeLinkRef[] = [
  {
    id: "link-1",
    url: "https://www.instagram.com/reel/taipei-breakfast/",
    title: "Part 1 | Favourite bites from my Taipei trip!",
    domain: "instagram.com",
    status: "done",
    created_at: "2026-09-11T18:40:00.000Z",
    depth: 1,
  },
  {
    id: "link-2",
    url: "https://www.instagram.com/reel/taipei-guide/",
    title: "🇹🇼 Comment TAIWAN and I’ll send you my full 6D5N Taipei itinerary",
    domain: "instagram.com",
    status: "done",
    created_at: "2026-07-04T09:02:00.000Z",
    depth: 1,
  },
  {
    id: "link-3",
    url: "https://www.threads.com/@someone/post/xyz",
    title: "Where to eat breakfast in Da’an",
    domain: "threads.com",
    status: "done",
    created_at: "2026-04-02T10:12:00.000Z",
    depth: 2,
  },
];
